import { Component, ElementRef, OnInit } from '@angular/core';
import { Subject, take, takeUntil } from "rxjs";
import { EditProfileModel } from "../../models/edit-profile/edit-profile.model";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { MessageService } from 'primeng/api';
import { UserModel } from "../../../share-modul/models/user/user.model";
import { CompressImageService } from "../../../share-modul/services/common/compress-image.service";
import {
  ChangePasswordDialogComponent
} from "../../../share-modul/components/change-password-dialog/change-password-dialog.component";

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public pictureIsWrongFormat: boolean = false;
  public editProfileModel: EditProfileModel = new EditProfileModel();
  public filePicture: any;
  public pictureFormat: Array<string>;
  public imagePath: string = './assets/images/logo/profile-picture-placeholder.png';
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public user: UserModel | null;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public imageChanged: boolean = false;
  public isWaiter: boolean = false;
  //#endregion

  //#region Constructor
  constructor(private openFile: ElementRef,
              private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private authenticationService: AuthenticationService,
              private dialogService: DialogService,
              private messageService: MessageService,
              private compressImage: CompressImageService) {

    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
  }

  ngOnInit(): void {
    if (this.config.data != undefined && this.config.data.isWaiter) {
      this.isWaiter = this.config.data.isWaiter;
    }
    this.authenticationService.loginUser.pipe(takeUntil(this.unsubscribe)).subscribe(user => {
      this.user = user;
    });
    if(this.isWaiter){
      this.getUserProfileForWaiter();
    } else {
      this.getUserProfile();
    }
  }
  //#endregion

  //#region Public Methods


  public getUserProfile() {
    this.spinner = true;
    this.authenticationService.getProfile(this.user?.roles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.editProfileModel = response;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  public getUserProfileForWaiter() {
    this.spinner = true;
    this.authenticationService.getWaiterProfile()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.editProfileModel = response;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  public updateProfile(model: EditProfileModel) {
    this.spinner = true;
    if(model.phone != null){
      model.phone = model.phone.toString();
    }
    this.authenticationService.updateProfile(model, this.user?.roles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.ref.close(true);
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  public updateWaiterProfile(model: EditProfileModel) {
    this.spinner = true;
    if(model.phone != null){
      model.phone = model.phone.toString();
    }
    this.authenticationService.updatWaitereProfile(model)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.ref.close(true);
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  cancel(): void {
    this.ref.close(this.imageChanged);
  }

  openAddImage(): void {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }

  onFileSelected(event: any): void {
    this.pictureIsWrongFormat = false;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (!this.pictureFormat.includes(event.target.files[0].type)) {
        this.pictureIsWrongFormat = true;
        return;
      }
      let image: File = event.target.files[0]
      reader.readAsDataURL(image);// read file as data url
      this.compressImage.compress(image)
        .pipe(take(1))
        .subscribe(compressedImage => {
          this.filePicture = compressedImage;
          this.changeProfilePicture();
        })
      reader.onload = (item) => { // called once readAsDataURL is completed
        if (item.target?.result) {
          this.editProfileModel.profilePictureUrl = item.target?.result as string;
        }
      }
    }
  }

  changeProfilePicture(): void {
    this.spinner = true;
    this.authenticationService.uploadProfilePicture(this.filePicture, this.user?.roles).pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.imageChanged = true;
          this.spinner = false;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  public changePassword(): void {
    this.dialogService.open(ChangePasswordDialogComponent, {
      closable: false,
      styleClass: 'small-header-dialog',
      width: '400px'
    });
  }
  //#endregion
}
